// SHADERS:
module.exports = function (THREE) {
  // STATS:
  THREE.THREEx = {};
  THREE.THREEx.RendererStats = function () {
    var e = document.createElement("div");
    e.style.cssText = "width:80px;opacity:0.9;cursor:pointer";
    var d = document.createElement("div");
    d.style.cssText = "padding:0 0 3px 3px;text-align:left;background-color:#200;";
    e.appendChild(d);
    var a = document.createElement("div");
    a.style.cssText = "color:#f00;font-family:Helvetica,Arial,sans-serif;font-size:9px;font-weight:bold;line-height:15px";
    a.innerHTML = "WebGLRenderer";
    d.appendChild(a);
    var b = [];
    for (a = 0; 9 > a; a++) {
      b[a] = document.createElement("div");
      b[a].style.cssText = "color:#f00;background-color:#311;font-family:Helvetica,Arial,sans-serif;font-size:9px;font-weight:bold;line-height:15px";
      d.appendChild(b[a]);
      b[a].innerHTML = "-";
    }
    var f = Date.now();
    return {
      domElement: e,
      update: function (a) {
        console.assert(a instanceof THREE.WebGLRenderer);
        if (!(Date.now() - f < 1E3 / 30)) {
          f = Date.now();
          var c = 0;
          b[c++].textContent = "== Memory =====";
          b[c++].textContent = "Programs: " + a.info.memory.programs;
          b[c++].textContent = "Geometries: " + a.info.memory.geometries;
          b[c++].textContent = "Textures: " + a.info.memory.textures;
          b[c++].textContent = "== Render =====";
          b[c++].textContent = "Calls: " + a.info.render.calls;
          b[c++].textContent = "Vertices: " + a.info.render.vertices;
          b[c++].textContent = "Faces: " + a.info.render.faces;
          b[c++].textContent = "Points: " + a.info.render.points;
        }
      }
    };
  };

  // SSAO:
  THREE.SSAOShader = {
    uniforms: {
      tDiffuse: {
        value: null
      },
      tDepth: {
        value: null
      },
      size: {
        value: new THREE.Vector2(64, 64)
      },
      cameraNear: {
        value: 1
      },
      cameraFar: {
        value: 100
      },
      radius: {
        value: 40
      },
      onlyAO: {
        value: 0
      },
      aoClamp: {
        value: 1
      },
      lumInfluence: {
        value: 0.7
      }
    },
    vertexShader: "varying vec2 vUv;\nvoid main() {\nvUv = uv;\ngl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}",
    fragmentShader: "uniform float cameraNear;\nuniform float cameraFar;\n#ifdef USE_LOGDEPTHBUF\nuniform float logDepthBufFC;\n#endif\nuniform float radius;\nuniform bool onlyAO;\nuniform vec2 size;\nuniform float aoClamp;\nuniform float lumInfluence;\nuniform sampler2D tDiffuse;\nuniform sampler2D tDepth;\nvarying vec2 vUv;\n#define DL 2.399963229728653\n#define EULER 2.718281828459045\nconst int samples = 8;\nconst bool useNoise = true;\nconst float noiseAmount = 0.0004;\nconst float diffArea = 0.4;\nconst float gDisplace = 0.4;\n#include <packing>\nvec2 rand( const vec2 coord ) {\nvec2 noise;\nif ( useNoise ) {\nfloat nx = dot ( coord, vec2( 12.9898, 78.233 ) );\nfloat ny = dot ( coord, vec2( 12.9898, 78.233 ) * 2.0 );\nnoise = clamp( fract ( 43758.5453 * sin( vec2( nx, ny ) ) ), 0.0, 1.0 );\n} else {\nfloat ff = fract( 1.0 - coord.s * ( size.x / 2.0 ) );\nfloat gg = fract( coord.t * ( size.y / 2.0 ) );\nnoise = vec2( 0.25, 0.75 ) * vec2( ff ) + vec2( 0.75, 0.25 ) * gg;\n}\nreturn ( noise * 2.0  - 1.0 ) * noiseAmount;\n}\nfloat readDepth( const in vec2 coord ) {\nfloat cameraFarPlusNear = cameraFar + cameraNear;\nfloat cameraFarMinusNear = cameraFar - cameraNear;\nfloat cameraCoef = 2.0 * cameraNear;\n#ifdef USE_LOGDEPTHBUF\nfloat logz = unpackRGBAToDepth( texture2D( tDepth, coord ) );\nfloat w = pow(2.0, (logz / logDepthBufFC)) - 1.0;\nfloat z = (logz / w) + 1.0;\n#else\nfloat z = unpackRGBAToDepth( texture2D( tDepth, coord ) );\n#endif\nreturn cameraCoef / ( cameraFarPlusNear - z * cameraFarMinusNear );\n}\nfloat compareDepths( const in float depth1, const in float depth2, inout int far ) {\nfloat garea = 8.0;\nfloat diff = ( depth1 - depth2 ) * 100.0;\nif ( diff < gDisplace ) {\ngarea = diffArea;\n} else {\nfar = 1;\n}\nfloat dd = diff - gDisplace;\nfloat gauss = pow( EULER, -2.0 * ( dd * dd ) / ( garea * garea ) );\nreturn gauss;\n}\nfloat calcAO( float depth, float dw, float dh ) {\nvec2 vv = vec2( dw, dh );\nvec2 coord1 = vUv + radius * vv;\nvec2 coord2 = vUv - radius * vv;\nfloat temp1 = 0.0;\nfloat temp2 = 0.0;\nint far = 0;\ntemp1 = compareDepths( depth, readDepth( coord1 ), far );\nif ( far > 0 ) {\ntemp2 = compareDepths( readDepth( coord2 ), depth, far );\ntemp1 += ( 1.0 - temp1 ) * temp2;\n}\nreturn temp1;\n}\nvoid main() {\nvec2 noise = rand( vUv );\nfloat depth = readDepth( vUv );\nfloat tt = clamp( depth, aoClamp, 1.0 );\nfloat w = ( 1.0 / size.x ) / tt + ( noise.x * ( 1.0 - noise.x ) );\nfloat h = ( 1.0 / size.y ) / tt + ( noise.y * ( 1.0 - noise.y ) );\nfloat ao = 0.0;\nfloat dz = 1.0 / float( samples );\nfloat l = 0.0;\nfloat z = 1.0 - dz / 2.0;\nfor ( int i = 0; i <= samples; i ++ ) {\nfloat r = sqrt( 1.0 - z );\nfloat pw = cos( l ) * r;\nfloat ph = sin( l ) * r;\nao += calcAO( depth, pw * w, ph * h );\nz = z - dz;\nl = l + DL;\n}\nao /= float( samples );\nao = 1.0 - ao;\nvec3 color = texture2D( tDiffuse, vUv ).rgb;\nvec3 lumcoeff = vec3( 0.299, 0.587, 0.114 );\nfloat lum = dot( color.rgb, lumcoeff );\nvec3 luminance = vec3( lum );\nvec3 final = vec3( color * mix( vec3( ao ), vec3( 1.0 ), luminance * lumInfluence ) );\nif ( onlyAO ) {\nfinal = vec3( mix( vec3( ao ), vec3( 1.0 ), luminance * lumInfluence ) );\n}\ngl_FragColor = vec4( final, 0.5 );\n}"
  };

  // COPY SHADER:
  THREE.CopyShader = {
    uniforms: {
      tDiffuse: {
        value: null
      },
      opacity: {
        value: 1
      }
    },
    vertexShader: "varying vec2 vUv;\nvoid main() {\nvUv = uv;\ngl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}",
    fragmentShader: "uniform float opacity;\nuniform sampler2D tDiffuse;\nvarying vec2 vUv;\nvoid main() {\nvec4 texel = texture2D( tDiffuse, vUv );\ngl_FragColor = opacity * texel;\n}"
  };

  // COMPOSER:
  THREE.EffectComposer = function (a, b) {
    this.renderer = a;
    if (void 0 === b) {
      var c = {
        minFilter: THREE.LinearFilter,
        magFilter: THREE.LinearFilter,
        format: THREE.RGBAFormat,
        stencilBuffer: !1
      };
      var e = a.getDrawingBufferSize();
      b = new THREE.WebGLRenderTarget(e.width, e.height, c);
      b.texture.name = "EffectComposer.rt1";
    }
    this.renderTarget1 = b;
    this.renderTarget2 = b.clone();
    this.renderTarget2.texture.name = "EffectComposer.rt2";
    this.writeBuffer = this.renderTarget1;
    this.readBuffer = this.renderTarget2;
    this.passes = [];
    void 0 === THREE.CopyShader && console.error("THREE.EffectComposer relies on THREE.CopyShader");
    void 0 === THREE.ShaderPass && console.error("THREE.EffectComposer relies on THREE.ShaderPass");
    this.copyPass = new THREE.ShaderPass(THREE.CopyShader);
  };
  Object.assign(THREE.EffectComposer.prototype, {
    swapBuffers: function () {
      var a = this.readBuffer;
      this.readBuffer = this.writeBuffer;
      this.writeBuffer = a;
    },
    addPass: function (a) {
      this.passes.push(a);
      var b = this.renderer.getDrawingBufferSize();
      a.setSize(b.width, b.height);
    },
    insertPass: function (a, b) {
      this.passes.splice(b, 0, a);
    },
    render: function (a) {
      var b = !1;
      var c;
      var e = this.passes.length;
      for (c = 0; c < e; c++) {
        var d = this.passes[c];
        if (!1 !== d.enabled) {
          d.render(this.renderer, this.writeBuffer, this.readBuffer, a, b);
          if (d.needsSwap) {
            if (b) {
              var f = this.renderer.context;
              f.stencilFunc(f.NOTEQUAL, 1, 4294967295);
              this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, a);
              f.stencilFunc(f.EQUAL, 1, 4294967295);
            }
            this.swapBuffers();
          }
          void 0 !== THREE.MaskPass && (d instanceof THREE.MaskPass ? b = !0 : d instanceof THREE.ClearMaskPass && (b = !1));
        }
      }
    },
    reset: function (a) {
      if (void 0 === a) {
        var b = this.renderer.getDrawingBufferSize();
        a = this.renderTarget1.clone();
        a.setSize(b.width, b.height);
      }
      this.renderTarget1.dispose();
      this.renderTarget2.dispose();
      this.renderTarget1 = a;
      this.renderTarget2 = a.clone();
      this.writeBuffer = this.renderTarget1;
      this.readBuffer = this.renderTarget2;
    },
    setSize: function (a, b) {
      this.renderTarget1.setSize(a, b);
      this.renderTarget2.setSize(a, b);
      for (var c = 0; c < this.passes.length; c++) {
        this.passes[c].setSize(a, b);
      }
    }
  });
  THREE.Pass = function () {
    this.needsSwap = this.enabled = !0;
    this.renderToScreen = this.clear = !1;
  };
  Object.assign(THREE.Pass.prototype, {
    setSize: function (a, b) {},
    render: function (a, b, c, e, d) {
      console.error("THREE.Pass: .render() must be implemented in derived pass.");
    }
  });

  // RENDER PASS:
  THREE.RenderPass = function (a, b, c, e, d) {
    THREE.Pass.call(this);
    this.scene = a;
    this.camera = b;
    this.overrideMaterial = c;
    this.clearColor = e;
    this.clearAlpha = void 0 !== d ? d : 0;
    this.clear = !0;
    this.needsSwap = this.clearDepth = !1;
  };
  THREE.RenderPass.prototype = Object.assign(Object.create(THREE.Pass.prototype), {
    constructor: THREE.RenderPass,
    render: function (a, b, c, e, d) {
      b = a.autoClear;
      a.autoClear = !1;
      this.scene.overrideMaterial = this.overrideMaterial;
      if (this.clearColor) {
        var f = a.getClearColor().getHex();
        var g = a.getClearAlpha();
        a.setClearColor(this.clearColor, this.clearAlpha);
      }
      this.clearDepth && a.clearDepth();
      a.render(this.scene, this.camera, this.renderToScreen ? null : c, this.clear);
      this.clearColor && a.setClearColor(f, g);
      this.scene.overrideMaterial = null;
      a.autoClear = b;
    }
  });

  // SHADER PASS:
  THREE.ShaderPass = function (a, b) {
    THREE.Pass.call(this);
    this.textureID = void 0 !== b ? b : "tDiffuse";
    a instanceof THREE.ShaderMaterial ? (this.uniforms = a.uniforms, this.material = a) : a && (this.uniforms = THREE.UniformsUtils.clone(a.uniforms), this.material = new THREE.ShaderMaterial({
      defines: Object.assign({}, a.defines),
      uniforms: this.uniforms,
      vertexShader: a.vertexShader,
      fragmentShader: a.fragmentShader
    }));
    this.camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    this.scene = new THREE.Scene();
    this.quad = new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 2), null);
    this.quad.frustumCulled = !1;
    this.scene.add(this.quad);
  };
  THREE.ShaderPass.prototype = Object.assign(Object.create(THREE.Pass.prototype), {
    constructor: THREE.ShaderPass,
    render: function (a, b, c, d, e) {
      this.uniforms[this.textureID] && (this.uniforms[this.textureID].value = c.texture);
      this.quad.material = this.material;
      this.renderToScreen ? a.render(this.scene, this.camera) : a.render(this.scene, this.camera, b, this.clear);
    }
  });

  // MASK PASS:
  THREE.MaskPass = function (c, d) {
    THREE.Pass.call(this);
    this.scene = c;
    this.camera = d;
    this.clear = !0;
    this.inverse = this.needsSwap = !1;
  };
  THREE.MaskPass.prototype = Object.assign(Object.create(THREE.Pass.prototype), {
    constructor: THREE.MaskPass,
    render: function (c, d, e, b, a) {
      b = c.context;
      a = c.state;
      a.buffers.color.setMask(!1);
      a.buffers.depth.setMask(!1);
      a.buffers.color.setLocked(!0);
      a.buffers.depth.setLocked(!0);
      if (this.inverse) {
        var f = 0;
        var g = 1;
      } else {
        f = 1;
        g = 0;
      }
      a.buffers.stencil.setTest(!0);
      a.buffers.stencil.setOp(b.REPLACE, b.REPLACE, b.REPLACE);
      a.buffers.stencil.setFunc(b.ALWAYS, f, 4294967295);
      a.buffers.stencil.setClear(g);
      c.render(this.scene, this.camera, e, this.clear);
      c.render(this.scene, this.camera, d, this.clear);
      a.buffers.color.setLocked(!1);
      a.buffers.depth.setLocked(!1);
      a.buffers.stencil.setFunc(b.EQUAL, 1, 4294967295);
      a.buffers.stencil.setOp(b.KEEP, b.KEEP, b.KEEP);
    }
  });
  THREE.ClearMaskPass = function () {
    THREE.Pass.call(this);
    this.needsSwap = !1;
  };
  THREE.ClearMaskPass.prototype = Object.create(THREE.Pass.prototype);
  Object.assign(THREE.ClearMaskPass.prototype, {
    render: function (c, d, e, b, a) {
      c.state.buffers.stencil.setTest(!1);
    }
  });

  // SSAO PASS:
  THREE.SSAOPass = function (a, b, c, d) {
    if (void 0 === THREE.SSAOShader) {
      console.warn("THREE.SSAOPass depends on THREE.SSAOShader");
      return new THREE.ShaderPass();
    }
    THREE.ShaderPass.call(this, THREE.SSAOShader);
    this.width = void 0 !== c ? c : 128;
    this.height = void 0 !== d ? d : 128;
    this.renderToScreen = !1;
    this.camera2 = b;
    this.scene2 = a;
    this.depthMaterial = new THREE.MeshDepthMaterial();
    this.depthMaterial.depthPacking = THREE.RGBADepthPacking;
    this.depthMaterial.blending = THREE.NoBlending;
    this.depthRenderTarget = new THREE.WebGLRenderTarget(this.width, this.height, {
      minFilter: THREE.LinearFilter,
      magFilter: THREE.LinearFilter
    });
    this.uniforms.tDepth.value = this.depthRenderTarget.texture;
    this.uniforms.size.value.set(this.width, this.height);
    this.uniforms.cameraNear.value = this.camera2.near;
    this.uniforms.cameraFar.value = this.camera2.far;
    this.uniforms.radius.value = 4;
    this.uniforms.onlyAO.value = !1;
    this.uniforms.aoClamp.value = .25;
    this.uniforms.lumInfluence.value = .7;
    Object.defineProperties(this, {
      radius: {
        get: function () {
          return this.uniforms.radius.value;
        },
        set: function (a) {
          this.uniforms.radius.value = a;
        }
      },
      onlyAO: {
        get: function () {
          return this.uniforms.onlyAO.value;
        },
        set: function (a) {
          this.uniforms.onlyAO.value = a;
        }
      },
      aoClamp: {
        get: function () {
          return this.uniforms.aoClamp.value;
        },
        set: function (a) {
          this.uniforms.aoClamp.value = a;
        }
      },
      lumInfluence: {
        get: function () {
          return this.uniforms.lumInfluence.value;
        },
        set: function (a) {
          this.uniforms.lumInfluence.value = a;
        }
      }
    });
  };
  THREE.SSAOPass.prototype = Object.create(THREE.ShaderPass.prototype);
  THREE.SSAOPass.prototype.render = function (a, b, c, d, e) {
    this.scene2.overrideMaterial = this.depthMaterial;
    a.render(this.scene2, this.camera2, this.depthRenderTarget, !0);
    this.scene2.overrideMaterial = null;
    THREE.ShaderPass.prototype.render.call(this, a, b, c, d, e);
  };
  THREE.SSAOPass.prototype.setScene = function (a) {
    this.scene2 = a;
  };
  THREE.SSAOPass.prototype.setCamera = function (a) {
    this.camera2 = a;
    this.uniforms.cameraNear.value = this.camera2.near;
    this.uniforms.cameraFar.value = this.camera2.far;
  };
  THREE.SSAOPass.prototype.setSize = function (a, b) {
    this.width = a;
    this.height = b;
    this.uniforms.size.value.set(this.width, this.height);
    this.depthRenderTarget.setSize(this.width, this.height);
  };

  // LUMINOSITY:
  THREE.LuminosityHighPassShader = {
    shaderID: "luminosityHighPass",
    uniforms: {
      tDiffuse: {
        type: "t",
        value: null
      },
      luminosityThreshold: {
        type: "f",
        value: 1
      },
      smoothWidth: {
        type: "f",
        value: 1
      },
      defaultColor: {
        type: "c",
        value: new THREE.Color(0)
      },
      defaultOpacity: {
        type: "f",
        value: 0
      }
    },
    vertexShader: "varying vec2 vUv;\nvoid main() {\nvUv = uv;\ngl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}",
    fragmentShader: "uniform sampler2D tDiffuse;\nuniform vec3 defaultColor;\nuniform float defaultOpacity;\nuniform float luminosityThreshold;\nuniform float smoothWidth;\nvarying vec2 vUv;\nvoid main() {\nvec4 texel = texture2D( tDiffuse, vUv );\nvec3 luma = vec3( 0.299, 0.587, 0.114 );\nfloat v = dot( texel.xyz, luma );\nvec4 outputColor = vec4( defaultColor.rgb, defaultOpacity );\nfloat alpha = smoothstep( luminosityThreshold, luminosityThreshold + smoothWidth, v );\ngl_FragColor = mix( outputColor, texel, alpha );\n}"
  };

  // BLOOM PASS:
  THREE.UnrealBloomPass = function (a, e, b, d) {
    THREE.Pass.call(this);
    this.strength = void 0 !== e ? e : 1;
    this.radius = b;
    this.threshold = d;
    this.resolution = void 0 !== a ? new THREE.Vector2(a.x, a.y) : new THREE.Vector2(256, 256);
    this.clearColor = new THREE.Color(0, 0, 0);
    var f = {
      minFilter: THREE.LinearFilter,
      magFilter: THREE.LinearFilter,
      format: THREE.RGBAFormat
    };
    this.renderTargetsHorizontal = [];
    this.renderTargetsVertical = [];
    this.nMips = 5;
    a = Math.round(this.resolution.x / 2);
    b = Math.round(this.resolution.y / 2);
    this.renderTargetBright = new THREE.WebGLRenderTarget(a, b, f);
    this.renderTargetBright.texture.name = "UnrealBloomPass.bright";
    this.renderTargetBright.texture.generateMipmaps = !1;
    for (var c = 0; c < this.nMips; c++) {
      var g = new THREE.WebGLRenderTarget(a, b, f);
      g.texture.name = "UnrealBloomPass.h" + c;
      g.texture.generateMipmaps = !1;
      this.renderTargetsHorizontal.push(g);
      g = new THREE.WebGLRenderTarget(a, b, f);
      g.texture.name = "UnrealBloomPass.v" + c;
      g.texture.generateMipmaps = !1;
      this.renderTargetsVertical.push(g);
      a = Math.round(a / 2);
      b = Math.round(b / 2);
    }
    void 0 === THREE.LuminosityHighPassShader && console.error("THREE.UnrealBloomPass relies on THREE.LuminosityHighPassShader");
    a = THREE.LuminosityHighPassShader;
    this.highPassUniforms = THREE.UniformsUtils.clone(a.uniforms);
    this.highPassUniforms.luminosityThreshold.value = d;
    this.highPassUniforms.smoothWidth.value = .01;
    this.materialHighPassFilter = new THREE.ShaderMaterial({
      uniforms: this.highPassUniforms,
      vertexShader: a.vertexShader,
      fragmentShader: a.fragmentShader,
      defines: {}
    });
    this.separableBlurMaterials = [];
    d = [3, 5, 7, 9, 11];
    a = Math.round(this.resolution.x / 2);
    b = Math.round(this.resolution.y / 2);
    for (c = 0; c < this.nMips; c++) {
      this.separableBlurMaterials.push(this.getSeperableBlurMaterial(d[c]));
      this.separableBlurMaterials[c].uniforms.texSize.value = new THREE.Vector2(a, b);
      a = Math.round(a / 2);
      b = Math.round(b / 2);
    }
    this.compositeMaterial = this.getCompositeMaterial(this.nMips);
    this.compositeMaterial.uniforms.blurTexture1.value = this.renderTargetsVertical[0].texture;
    this.compositeMaterial.uniforms.blurTexture2.value = this.renderTargetsVertical[1].texture;
    this.compositeMaterial.uniforms.blurTexture3.value = this.renderTargetsVertical[2].texture;
    this.compositeMaterial.uniforms.blurTexture4.value = this.renderTargetsVertical[3].texture;
    this.compositeMaterial.uniforms.blurTexture5.value = this.renderTargetsVertical[4].texture;
    this.compositeMaterial.uniforms.bloomStrength.value = e;
    this.compositeMaterial.uniforms.bloomRadius.value = .1;
    this.compositeMaterial.needsUpdate = !0;
    this.compositeMaterial.uniforms.bloomFactors.value = [1, .8, .6, .4, .2];
    this.bloomTintColors = [new THREE.Vector3(1, 1, 1), new THREE.Vector3(1, 1, 1), new THREE.Vector3(1, 1, 1), new THREE.Vector3(1, 1, 1), new THREE.Vector3(1, 1, 1)];
    this.compositeMaterial.uniforms.bloomTintColors.value = this.bloomTintColors;
    void 0 === THREE.CopyShader && console.error("THREE.BloomPass relies on THREE.CopyShader");
    e = THREE.CopyShader;
    this.copyUniforms = THREE.UniformsUtils.clone(e.uniforms);
    this.copyUniforms.opacity.value = 1;
    this.materialCopy = new THREE.ShaderMaterial({
      uniforms: this.copyUniforms,
      vertexShader: e.vertexShader,
      fragmentShader: e.fragmentShader,
      blending: THREE.AdditiveBlending,
      depthTest: !1,
      depthWrite: !1,
      transparent: !0
    });
    this.enabled = !0;
    this.needsSwap = !1;
    this.oldClearColor = new THREE.Color();
    this.oldClearAlpha = 1;
    this.camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    this.scene = new THREE.Scene();
    this.basic = new THREE.MeshBasicMaterial();
    this.quad = new THREE.Mesh(new THREE.PlaneBufferGeometry(2, 2), null);
    this.quad.frustumCulled = !1;
    this.scene.add(this.quad);
  };
  THREE.UnrealBloomPass.prototype = Object.assign(Object.create(THREE.Pass.prototype), {
    constructor: THREE.UnrealBloomPass,
    dispose: function () {
      for (var a = 0; a < this.renderTargetsHorizontal.length; a++) {
        this.renderTargetsHorizontal[a].dispose();
      }
      for (a = 0; a < this.renderTargetsVertical.length; a++) {
        this.renderTargetsVertical[a].dispose();
      }
      this.renderTargetBright.dispose();
    },
    setSize: function (a, e) {
      var b = Math.round(a / 2);
      var d = Math.round(e / 2);
      this.renderTargetBright.setSize(b, d);
      for (var f = 0; f < this.nMips; f++) {
        this.renderTargetsHorizontal[f].setSize(b, d);
        this.renderTargetsVertical[f].setSize(b, d);
        this.separableBlurMaterials[f].uniforms.texSize.value = new THREE.Vector2(b, d);
        b = Math.round(b / 2);
        d = Math.round(d / 2);
      }
    },
    render: function (a, e, b, d, f) {
      this.oldClearColor.copy(a.getClearColor());
      this.oldClearAlpha = a.getClearAlpha();
      e = a.autoClear;
      a.autoClear = !1;
      a.setClearColor(this.clearColor, 0);
      f && a.context.disable(a.context.STENCIL_TEST);
      this.renderToScreen && (this.quad.material = this.basic, this.basic.map = b.texture, a.render(this.scene, this.camera, void 0, !0));
      this.highPassUniforms.tDiffuse.value = b.texture;
      this.highPassUniforms.luminosityThreshold.value = this.threshold;
      this.quad.material = this.materialHighPassFilter;
      a.render(this.scene, this.camera, this.renderTargetBright, !0);
      d = this.renderTargetBright;
      for (var c = 0; c < this.nMips; c++) {
        this.quad.material = this.separableBlurMaterials[c];
        this.separableBlurMaterials[c].uniforms.colorTexture.value = d.texture;
        this.separableBlurMaterials[c].uniforms.direction.value = THREE.UnrealBloomPass.BlurDirectionX;
        a.render(this.scene, this.camera, this.renderTargetsHorizontal[c], !0);
        this.separableBlurMaterials[c].uniforms.colorTexture.value = this.renderTargetsHorizontal[c].texture;
        this.separableBlurMaterials[c].uniforms.direction.value = THREE.UnrealBloomPass.BlurDirectionY;
        a.render(this.scene, this.camera, this.renderTargetsVertical[c], !0);
        d = this.renderTargetsVertical[c];
      }
      this.quad.material = this.compositeMaterial;
      this.compositeMaterial.uniforms.bloomStrength.value = this.strength;
      this.compositeMaterial.uniforms.bloomRadius.value = this.radius;
      this.compositeMaterial.uniforms.bloomTintColors.value = this.bloomTintColors;
      a.render(this.scene, this.camera, this.renderTargetsHorizontal[0], !0);
      this.quad.material = this.materialCopy;
      this.copyUniforms.tDiffuse.value = this.renderTargetsHorizontal[0].texture;
      f && a.context.enable(a.context.STENCIL_TEST);
      this.renderToScreen ? a.render(this.scene, this.camera, void 0, !1) : a.render(this.scene, this.camera, b, !1);
      a.setClearColor(this.oldClearColor, this.oldClearAlpha);
      a.autoClear = e;
    },
    getSeperableBlurMaterial: function (a) {
      return new THREE.ShaderMaterial({
        defines: {
          KERNEL_RADIUS: a,
          SIGMA: a
        },
        uniforms: {
          colorTexture: {
            value: null
          },
          texSize: {
            value: new THREE.Vector2(.5, .5)
          },
          direction: {
            value: new THREE.Vector2(.5, .5)
          }
        },
        vertexShader: "varying vec2 vUv;\n\t\t\t\tvoid main() {\n\t\t\t\t\tvUv = uv;\n\t\t\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\t\t\t\t}",
        fragmentShader: "#include <common>\t\t\t\tvarying vec2 vUv;\n\t\t\t\tuniform sampler2D colorTexture;\n\t\t\t\tuniform vec2 texSize;\t\t\t\tuniform vec2 direction;\t\t\t\t\t\t\t\tfloat gaussianPdf(in float x, in float sigma) {\t\t\t\t\treturn 0.39894 * exp( -0.5 * x * x/( sigma * sigma))/sigma;\t\t\t\t}\t\t\t\tvoid main() {\n\t\t\t\t\tvec2 invSize = 1.0 / texSize;\t\t\t\t\tfloat fSigma = float(SIGMA);\t\t\t\t\tfloat weightSum = gaussianPdf(0.0, fSigma);\t\t\t\t\tvec3 diffuseSum = texture2D( colorTexture, vUv).rgb * weightSum;\t\t\t\t\tfor( int i = 1; i < KERNEL_RADIUS; i ++ ) {\t\t\t\t\t\tfloat x = float(i);\t\t\t\t\t\tfloat w = gaussianPdf(x, fSigma);\t\t\t\t\t\tvec2 uvOffset = direction * invSize * x;\t\t\t\t\t\tvec3 sample1 = texture2D( colorTexture, vUv + uvOffset).rgb;\t\t\t\t\t\tvec3 sample2 = texture2D( colorTexture, vUv - uvOffset).rgb;\t\t\t\t\t\tdiffuseSum += (sample1 + sample2) * w;\t\t\t\t\t\tweightSum += 2.0 * w;\t\t\t\t\t}\t\t\t\t\tgl_FragColor = vec4(diffuseSum/weightSum, 1.0);\n\t\t\t\t}"
      });
    },
    getCompositeMaterial: function (a) {
      return new THREE.ShaderMaterial({
        defines: {
          NUM_MIPS: a
        },
        uniforms: {
          blurTexture1: {
            value: null
          },
          blurTexture2: {
            value: null
          },
          blurTexture3: {
            value: null
          },
          blurTexture4: {
            value: null
          },
          blurTexture5: {
            value: null
          },
          dirtTexture: {
            value: null
          },
          bloomStrength: {
            value: 1
          },
          bloomFactors: {
            value: null
          },
          bloomTintColors: {
            value: null
          },
          bloomRadius: {
            value: 0
          }
        },
        vertexShader: "varying vec2 vUv;\n\t\t\t\tvoid main() {\n\t\t\t\t\tvUv = uv;\n\t\t\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\t\t\t\t}",
        fragmentShader: "varying vec2 vUv;\t\t\t\tuniform sampler2D blurTexture1;\t\t\t\tuniform sampler2D blurTexture2;\t\t\t\tuniform sampler2D blurTexture3;\t\t\t\tuniform sampler2D blurTexture4;\t\t\t\tuniform sampler2D blurTexture5;\t\t\t\tuniform sampler2D dirtTexture;\t\t\t\tuniform float bloomStrength;\t\t\t\tuniform float bloomRadius;\t\t\t\tuniform float bloomFactors[NUM_MIPS];\t\t\t\tuniform vec3 bloomTintColors[NUM_MIPS];\t\t\t\t\t\t\t\tfloat lerpBloomFactor(const in float factor) { \t\t\t\t\tfloat mirrorFactor = 1.2 - factor;\t\t\t\t\treturn mix(factor, mirrorFactor, bloomRadius);\t\t\t\t}\t\t\t\t\t\t\t\tvoid main() {\t\t\t\t\tgl_FragColor = bloomStrength * ( lerpBloomFactor(bloomFactors[0]) * vec4(bloomTintColors[0], 1.0) * texture2D(blurTexture1, vUv) + \t\t\t\t\t\t\t\t\t\t\t\t\t lerpBloomFactor(bloomFactors[1]) * vec4(bloomTintColors[1], 1.0) * texture2D(blurTexture2, vUv) + \t\t\t\t\t\t\t\t\t\t\t\t\t lerpBloomFactor(bloomFactors[2]) * vec4(bloomTintColors[2], 1.0) * texture2D(blurTexture3, vUv) + \t\t\t\t\t\t\t\t\t\t\t\t\t lerpBloomFactor(bloomFactors[3]) * vec4(bloomTintColors[3], 1.0) * texture2D(blurTexture4, vUv) + \t\t\t\t\t\t\t\t\t\t\t\t\t lerpBloomFactor(bloomFactors[4]) * vec4(bloomTintColors[4], 1.0) * texture2D(blurTexture5, vUv) );\t\t\t\t}"
      });
    }
  });
  THREE.UnrealBloomPass.BlurDirectionX = new THREE.Vector2(1, 0);
  THREE.UnrealBloomPass.BlurDirectionY = new THREE.Vector2(0, 1);

  // STRIPPED LAMBERT:
  // See definition: https://github.com/mrdoob/three.js/blob/dev/src/materials/MeshLambertMaterial.js
  // See chunks: https://github.com/mrdoob/three.js/tree/dev/src/renderers/shaders/ShaderChunk
  // See frag: https://github.com/mrdoob/three.js/blob/dev/src/renderers/shaders/ShaderLib/meshlambert_frag.glsl.js
  // See vert: https://github.com/mrdoob/three.js/blob/dev/src/renderers/shaders/ShaderLib/meshlambert_vert.glsl.js
  THREE.StrippedLambertMaterial = function (parameters) {
    let material = new THREE.ShaderMaterial({
      name: "lambert-stripped",
      uniforms: THREE.UniformsUtils.merge([THREE.ShaderLib.lambert.uniforms]),
      lights: true,
      fog: true,
      vertexShader: `
  #define LAMBERT
  varying vec3 vLightFront;
  varying vec3 vIndirectFront;
  #ifdef DOUBLE_SIDED
      varying vec3 vLightBack;
      varying vec3 vIndirectBack;
  #endif
  #include <common>
  #include <uv_pars_vertex>
  #include <uv2_pars_vertex>
  // #include <envmap_pars_vertex>
  #include <bsdfs>
  #include <lights_pars_begin>
  #include <color_pars_vertex>
  #include <fog_pars_vertex>
  // #include <morphtarget_pars_vertex>
  // #include <skinning_pars_vertex>
  #include <shadowmap_pars_vertex>
  // #include <logdepthbuf_pars_vertex>
  // #include <clipping_planes_pars_vertex>
  void main() {
      #include <uv_vertex>
      #include <uv2_vertex>
      #include <color_vertex>
      #include <beginnormal_vertex>
      // #include <morphnormal_vertex>
      // #include <skinbase_vertex>
      // #include <skinnormal_vertex>
      #include <defaultnormal_vertex>
      #include <begin_vertex>
      // #include <morphtarget_vertex>
      // #include <skinning_vertex>
      #include <project_vertex>
      // #include <logdepthbuf_vertex>
      // #include <clipping_planes_vertex>
      #include <worldpos_vertex>
      // #include <envmap_vertex>
      #include <lights_lambert_vertex>
      #include <shadowmap_vertex>
      #include <fog_vertex>
  }
  `,
      fragmentShader: `
  uniform vec3 diffuse;
  uniform vec3 emissive;
  uniform float opacity;
  
  varying vec3 vLightFront;
  varying vec3 vIndirectFront;
  
  #ifdef DOUBLE_SIDED
      varying vec3 vLightBack;
      varying vec3 vIndirectBack;
  #endif
  
  
  #include <common>
  #include <packing>
  // #include <dithering_pars_fragment>
  #include <color_pars_fragment>
  #include <uv_pars_fragment>
  #include <uv2_pars_fragment>
  #include <map_pars_fragment>
  // #include <alphamap_pars_fragment>
  #include <aomap_pars_fragment>
  #include <lightmap_pars_fragment>
  #include <emissivemap_pars_fragment>
  // #include <envmap_pars_fragment>
  #include <bsdfs>  // Shading functions
  #include <lights_pars_begin>
  #include <fog_pars_fragment>
  #include <shadowmap_pars_fragment>
  #include <shadowmask_pars_fragment>
  // #include <specularmap_pars_fragment>
  // #include <logdepthbuf_pars_fragment>
  // #include <clipping_planes_pars_fragment>
  
  void main() {
  
      // #include <clipping_planes_fragment>
  
      vec4 diffuseColor = vec4( diffuse, opacity );
      ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
      vec3 totalEmissiveRadiance = emissive;
  
      // #include <logdepthbuf_fragment>
      #include <map_fragment>
      #include <color_fragment>
      // #include <alphamap_fragment>
      #include <alphatest_fragment>
      // #include <specularmap_fragment>
      #include <emissivemap_fragment>
  
      // accumulation
      reflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );
  
      #ifdef DOUBLE_SIDED
  
          reflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;
  
      #else
  
          reflectedLight.indirectDiffuse += vIndirectFront;
  
      #endif
  
      #include <lightmap_fragment>
  
      reflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );
  
      #ifdef DOUBLE_SIDED
  
          reflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;
  
      #else
  
          reflectedLight.directDiffuse = vLightFront;
  
      #endif
  
      reflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();
  
      // modulation
      #include <aomap_fragment>
  
      vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
  
      // #include <envmap_fragment>
  
      gl_FragColor = vec4( outgoingLight, diffuseColor.a );
  
      // #include <tonemapping_fragment>
      // #include <encodings_fragment>
      #include <fog_fragment>
      #include <premultiplied_alpha_fragment>
      // #include <dithering_fragment>
  }
      `
    });

    // // Define properties that forward their value to the uniforms
    // let swizzledProperties = {
    //     "color": "diffuse",
    //     // "emissive": "emissive",
    // };
    // for (let prop in swizzledProperties) {
    //     let uniformKey = swizzledProperties[prop];
    //     Object.defineProperty(material, prop, {
    //         get() {
    //             return material.uniforms[uniformKey].value;
    //         },

    //         set(v) {
    //             material.uniforms[uniformKey].value = v;
    //         }
    //     });
    // }
    // console.log("unifroms", material.uniforms);

    // Apply properties from lambert material
    Object.assign(material, new THREE.MeshLambertMaterial(parameters));

    // Flag as lambert material so other uniforms are applied appropriately
    // material.isShaderMaterial = false;
    material.isMeshLambertMaterial = true;

    // Set initial parameters
    material.setValues(parameters);
    return material;
  };
};